<template>
  <div v-show="visible" class="dialogue-container" @click="next">
    <!-- 左边角色区域 -->
    <div class="talk-box left">
      <img :src="leftCharacter.avatar" class="avatar" :class="[{ active: current.position === 'left'  }, leftCharacter.className]" />
      <div class="bubble" v-if="current.position === 'left'">
        <div class="text">{{ displayedText }}</div>
      </div>
    </div>

    <!-- 右边角色区域 -->
    <div class="talk-box right">
      <div class="bubble" v-if="current.position === 'right'">
        <div class="text">{{ displayedText }}</div>
      </div>
      <img :src="rightCharacter.avatar" class="avatar" :class="[{ active: current.position === 'right' }, rightCharacter.className]" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogueSide',
  props: {
    visible: Boolean,
    dialogues: Array,
  },
  data() {
    return {
      index: 0,
      typing: false,
      displayedText: '',
      typeTimer: null,
      fallbackLeftSpeaker: null,
      fallbackRightSpeaker: null,
    };
  },
  computed: {
    current() {
      const obj = this.dialogues[this.index] || {}
      return obj;
    },
    nextSpeaker() {
      // 获取下一个角色，如果没有就用当前补位
      return this.dialogues[this.index + 1] || this.dialogues[this.index] || {};
    },
    beforeSpeaker() {
      // 获取上一个角色，如果没有就用当前补位
      return this.dialogues[this.index - 1] || this.dialogues[this.index] || {};
    },
    leftCharacter() {
      return [this.current, this.nextSpeaker, this.beforeSpeaker].find(
        item => item.position === 'left'
      ) || this.fallbackLeftSpeaker || {}
    },
    rightCharacter() {
      return [this.current, this.nextSpeaker, this.beforeSpeaker].find(
        item => item.position === 'right'
      ) || this.fallbackRightSpeaker || {}
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.index = 0;
        this.startTyping();
      }
    },
    dialogues: {
      handler(val) {
        if (val && val.length > 0) {
          this.initFallbackSpeakers();
        }
      },
      immediate: true // 监听页面首次赋值也能执行
    }
  },
  methods: {
    initFallbackSpeakers() {
      this.fallbackLeftSpeaker =
        this.dialogues.find(d => d.position === 'left') || {};
      this.fallbackRightSpeaker =
        this.dialogues.find(d => d.position === 'right') || {};
    },
    startTyping() {
      const full = this.current.text;
      let i = 0;
      this.typing = true;
      this.displayedText = '';
      clearInterval(this.typeTimer);
      this.typeTimer = setInterval(() => {
        this.displayedText += full[i++];
        if (i >= full.length) {
          clearInterval(this.typeTimer);
          this.typing = false;
        }
      }, 80);
    },
    next() {
      if (this.typing) {
        return;
      }

      if (this.index < this.dialogues.length - 1) {
        this.index++;
        this.startTyping();
      } else {
        this.$emit('close');
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.typeTimer);
  }
};
</script>

<style scoped>
.dialogue-container {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  justify-content: space-between;
  pointer-events: auto;
  z-index: 9999;
  padding: 0 20px;
  background: url('https://download4.qcplay.com/h5-images/active/ares/anniversary/mengban.png')
    no-repeat;
  background-size: 100% 100%;
  transform: translateZ(100px);
}

.talk-box {
  display: flex;
  align-items: flex-start;
  pointer-events: auto;
  cursor: pointer;
  margin-top: auto;
}

.talk-box.left {
  flex-direction: row;
  justify-content: flex-start;
}

.talk-box.right {
  /* flex-direction: row-reverse; */
  margin-left: auto;
  justify-content: flex-end;
}

.avatar {
  width: 344px;
  height: 357px;
  margin: 0 10px;
  filter: grayscale(100%) brightness(0.6);
  transition: filter 0.3s;
}

.dialog-laozhenzhang {
  width: 333px;
  height: 356px;
}

.dialog-yinhu {
  width: 359px;
  height: 380px;
}

.dialog-laojunren {
  width: 333px;
  height: 356px;
}

.dialog-nike {
  width: 390px;
  height: 358px;
}

.dialog-huge {
  width: 332px;
  height: 347px;
}

.dialog-tieniu {
  width: 352px;
  height: 383px;
}

.dialog-laowu {
  width: 350px;
  height: 359px;
}

.dialog-mashu {
  width: 355px;
  height: 351px;
}

.dialog-dazhuang {
  width: 351px;
  height: 366px;
}

.dialog-hante {
  width: 289px;
  height: 351px;
}

.dialog-jiangna {
  width: 321px;
  height: 358px;
}
.dialog-niao {
  width: 405px;
  height: 357px;
}
.dialog-lin {
  width: 265px;
  height: 359px;
}
.dialog-tiechui {
  width: 344px;
  height: 357px;
}

.avatar.active {
  filter: none;
}

.bubble {
  background: #fff;
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  color: #333;
  font-size: 24px;
  line-height: 1.4;
  max-width: 400px;
  min-width: 180px;
  position: relative;
  margin-top: 50px;
  min-height: 36px;
}
/* 泡泡尾巴 */
.bubble::after {
  content: '';
  position: absolute;
  top: 12px;
  width: 0;
  height: 0;
  border-style: solid;
}

/* 左侧角色说话 — 尾巴朝左 */
.talk-box.left .bubble::after {
  left: -10px;
  border-width: 14px 14px 14px 0;
  border-color: transparent #fff transparent transparent;
}

/* 右侧角色说话 — 尾巴朝右 */
.talk-box.right .bubble::after {
  right: -10px;
  border-width: 14px 0 14px 14px;
  border-color: transparent transparent transparent #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/ares/anniversary/components/UnlockDialogueModal.vue